import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CatalogState = {
  categories: CatalogCategory[];
  services: CatalogService[];
  serviceConfig: CatalogServiceConfig | null;
};

export const catalogInitialState: CatalogState = {
  categories: [],
  services: [],
  serviceConfig: null,
};

const slice = createSlice({
  name: 'catalog',
  initialState: catalogInitialState,
  reducers: {
    setCatalogCategoriesAction(state, { payload }: PayloadAction<CatalogCategory[]>) {
      state.categories = payload;
    },
    setCatalogServicesAction(state, { payload }: PayloadAction<CatalogService[]>) {
      state.services = payload;
    },
    setCatalogServiceConfigAction(
      state,
      { payload }: PayloadAction<CatalogServiceConfig | null>,
    ) {
      state.serviceConfig = payload;
    },
    clearCatalogServicesAction(state) {
      state.services = [];
      state.serviceConfig = null;
    },
    clearCatalogServiceConfigAction(state) {
      state.serviceConfig = null;
    },
  },
});

export const {
  setCatalogCategoriesAction,
  setCatalogServicesAction,
  setCatalogServiceConfigAction,
  clearCatalogServicesAction,
  clearCatalogServiceConfigAction,
} = slice.actions;
export default slice.reducer;
